import Typography from "@mui/material/Typography";
import BoxContent from "../../../../shared/ui/BoxContent";
import FormField from "../../../../shared/form/FormField";

const CustomDuration = ({duration, errors, handleInputChange}: any) => {
    return (
        <>
            <Typography variant="h3" mt={3} mb={3}>
               Introdu durata testului în minute
            </Typography>
            <BoxContent>
                <FormField
                    name="custom_duration"
                    type="controlled-number"
                    label="Durata testului în minute (număr întreg între 1 și 240)"
                    value={duration}
                    inputProps={{min: 1, max: 240}}
                    onChange={handleInputChange}
                    errorMessage={errors.custom_duration?.message}
                    error={!!errors.custom_duration?.message}
                />
                <Typography variant="body1" mb={3}></Typography>
            </BoxContent>
        </>
    )
}

export default CustomDuration;